import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFSISArgs, FPSISGroupedResponse } from "@funds/models";
import { ThunkApiConfig } from "@shared/models/redux";

export const fetchFPSISGrouped = createAsyncThunk<FPSISGroupedResponse, fetchFSISArgs, ThunkApiConfig>(
  "funds/fetchFPSISGrouped",
  async ({ fundId, date }, { rejectWithValue, extra, signal }) => {
    try {
      const { status, data } = await extra<FPSISGroupedResponse>(
        `/reporting/v1/FPSIS/${encodeURIComponent(fundId)}/${encodeURIComponent(date.split("T")[0])}/grouped`,
        { signal }
      );

      if (status === 404) {
        throw Error("FSIS grouped reports not found");
      }

      return data;
    } catch (e) {
      return rejectWithValue("Failed to fetch grouped FSIS reports");
    }
  }
);
